<template>
  <div class="LinerNotes">
    <ul>
      <template v-for="(item,index) in notes">
        <li :key="index">
          <h3>{{`${index+1}.`}} {{item.title}}</h3>
          <p>{{item.text}}</p>
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
import NOTES from '../const/notes'
export default {
  name: 'LinerNotes',
  data() {
    return {
      notes: NOTES
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
ul {
  margin: 0;
  padding: 0;
}

ul li {
  color: #333;
  list-style-type: none;
  margin-bottom: 25px;
  text-align: left;
  @media screen and (max-width: 768px) {
    margin-bottom: 20px;
  }

  & > h3 {
    margin: 0 0 6px;
    font-size: 18px;
    @media screen and (max-width: 768px) {
      font-size: 15px;
    }
  }

  & > p {
    text-align: left;
    text-indent: 1em;
    font-size: 14px;
    @media screen and (max-width: 768px) {
      font-size: 13px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/LinerNotes.vue